/* In-page anchor links (#plan and friends) on the brand layer.
 *
 * At >=990px the page scrolls inside .page-wrapper, and three native
 * behaviours fail there: fragment navigation does not scroll the inner
 * scroller, Horizon's own click handling cancels the navigation (the
 * URL gains the hash, nothing moves), and smooth scrolls of any kind
 * are swallowed on that wrapper — only explicit instant scrolls stick.
 * So pure-fragment links whose target exists are claimed in the CAPTURE
 * phase, before the theme's router sees them, and jumped to instantly;
 * scroll-margin-top on the target keeps it clear of the sticky header.
 * Links to other pages, bare "#", and fragments without a matching
 * element pass through untouched. */
document.addEventListener(
  'click',
  function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    history.pushState(null, '', '#' + id);
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
  },
  true
);
